import React from 'react';
import { siteData } from '../mock';

const Hero = () => {
  const { hero } = siteData;
  return (
    <section className="relative min-h-screen w-full overflow-hidden bg-[#0a1030]">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${hero.backgroundImage})` }}
      />
      {/* Blue overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a1030]/85 via-[#0a1445]/70 to-[#050818]/90" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(30,60,150,0.25),transparent_70%)]" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-6 text-center">
        <h1
          className="font-serif-display text-white text-[52px] sm:text-[68px] md:text-[92px] lg:text-[110px] leading-[1.05] tracking-tight max-w-[1200px] mx-auto"
          style={{ fontFamily: 'Fraunces, serif', fontWeight: 500 }}
        >
          {hero.title}
        </h1>
        <p className="mt-8 max-w-[880px] text-white/90 text-[17px] md:text-[19px] leading-[1.7]">
          {hero.description.split('( ACT )').map((part, i, arr) =>
            i < arr.length - 1 ? (
              <React.Fragment key={i}>
                {part}
                <span className="font-semibold">( ACT )</span>
              </React.Fragment>
            ) : (
              part
            )
          )}
        </p>

        {/* Scroll cue */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/60 text-xs tracking-widest">
          <span>SCROLL</span>
          <div className="w-[1px] h-10 bg-white/40 animate-pulse" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
